// extracted by mini-css-extract-plugin
module.exports = {"home-battery-A":"A_home-battery-A__92l4N"};